import React from 'react';

function fmtPct(v) {
  if (v === null || v === undefined) return '—';
  const n = Number(v);
  return `${n >= 0 ? '+' : ''}${n.toFixed(1)}%`;
}

function Stat({ label, value, color }) {
  return (
    <div>
      <div style={{ color: 'var(--muted)', fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.3 }}>
        {label}
      </div>
      <div style={{ fontWeight: 700, fontSize: 13, color: color || 'var(--text)' }}>{value}</div>
    </div>
  );
}

// Renders a compact backtest results card inline in a chat message. Backtest
// results don't include a stored win_rate_pct (see strategies/engine.py) —
// it's computed here from won_trades/total_trades.
export default function BacktestSummaryCard({ backtest, onViewResults }) {
  if (!backtest) return null;
  const r = backtest.results || {};
  const winRate = r.total_trades ? (r.won_trades / r.total_trades) * 100 : null;
  const isGood = (r.return_pct || 0) > 0;

  return (
    <div style={{
      marginTop: 6,
      padding: 12,
      borderRadius: 8,
      background: 'var(--surface)',
      border: '1px solid var(--border)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontWeight: 700, fontSize: 13 }}>{backtest.symbol}</div>
        <div style={{ fontSize: 11, color: 'var(--muted)' }}>
          {backtest.start_date} → {backtest.end_date}
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
        <Stat label="Return" value={fmtPct(r.return_pct)} color={isGood ? 'var(--teal)' : 'var(--red)'} />
        <Stat label="Sharpe" value={r.sharpe_ratio != null ? Number(r.sharpe_ratio).toFixed(2) : '—'} />
        <Stat label="Max DD" value={fmtPct(r.max_drawdown_pct)} color="var(--red)" />
        <Stat label="Trades" value={r.total_trades ?? '—'} />
        <Stat label="Win Rate" value={winRate != null ? `${winRate.toFixed(0)}%` : '—'} />
        <Stat
          label="Net Profit"
          value={r.net_profit != null ? `$${Number(r.net_profit).toLocaleString(undefined, { maximumFractionDigits: 0 })}` : '—'}
          color={isGood ? 'var(--teal)' : 'var(--red)'}
        />
      </div>
      {onViewResults && (
        <button
          onClick={() => onViewResults(backtest)}
          style={{
            marginTop: 10,
            width: '100%',
            padding: '7px 10px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 700,
            cursor: 'pointer',
            background: 'var(--teal)',
            color: 'var(--bg)',
            border: 'none',
          }}
        >
          View Full Results →
        </button>
      )}
    </div>
  );
}
